import { createAction } from 'redux-actions';
export var NAMES = {
    ALL: 'CLIENT.VIDEO_URLS.CLEAR_ALL',
    FOR_ITEM: 'CLIENT.VIDEO_URLS.CLEAR_FOR_ITEM',
};
export var clearVideoUrlsCacheForAll = createAction(NAMES.ALL);
export var clearVideoUrlsCacheForItem = createAction(NAMES.FOR_ITEM);
